import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { Location } from '../modal/location';

export interface EditLocationParams {
  fieldId: string;
  fieldName: string;
}

export const updateLocationAPI = async ({
  fieldId,
  fieldName,
}: EditLocationParams) => {
  const resp = await baseAPI.patch<Location>(`/custom-form/${fieldId}`, {
    fieldName,
    fieldId,
    fieldType: 'location',
  });
  return resp.data;
};

export const useUpdateLocationMutation = () => {
  return useMutation({
    mutationFn: async (params: EditLocationParams) => {
      const response = await updateLocationAPI(params);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.LOCATIONS,
      });
    },
  });
};
